let stepRequest = null;
let descriptionRequest = null;

function wizardCard() {
    return $('.card.card-wizard');
}

export function wizardStepRequestPending() {
    return stepRequest !== null;
}

export function resetWizardStepRequest() {
    const abandoned = stepRequest;

    stepRequest = null;

    abortRequest(abandoned);
    setStepPending(false);
}

function abortRequest(request) {
    if (request) request.abort();
}

function setStepPending(pending) {
    const wizard = wizardCard();

    wizard.toggleClass('wizard-step-pending', pending);
    wizard.find('.btn-next, .btn-previous, .btn-finish, #product_select').prop('disabled', pending);
    wizard.find('.wizard-navigation .nav-link')
        .attr('aria-disabled', pending ? 'true' : null)
        .attr('tabindex', pending ? '-1' : null);
}

function declinedRequest(reason) {
    return $.Deferred().reject(reason).promise();
}

function wizardMessage(name) {
    return wizardCard().data(name);
}

function scriptRequest(url, data) {
    return $.ajax({
        type: 'GET',
        url: url,
        data: data,
        dataType: 'script'
    });
}

export function wizardRequest(form, url, data) {
    if (stepRequest) {
        showFlash('info', wizardMessage('step-request-pending-message'));
        return declinedRequest('pending');
    }

    if (!form.length) {
        showFlash('danger', wizardMessage('step-request-failed-message'));
        return declinedRequest('missing-form');
    }

    const requestUrl = url || form[0].action;
    const payload = data || form.serialize();

    setStepPending(true);

    const outcome = $.Deferred();
    const request = scriptRequest(requestUrl, payload);
    const isCurrent = () => stepRequest === request;

    stepRequest = request;

    request.done(function() {
        if (!isCurrent()) return outcome.reject('abandoned');

        settleStepRequest();
        outcome.resolve();
    }).fail(function() {
        if (!isCurrent()) return outcome.reject('abandoned');

        settleStepRequest();
        showFlash('danger', wizardMessage('step-request-failed-message'));
        outcome.reject('failed');
    });

    return outcome.promise();
}

function settleStepRequest() {
    stepRequest = null;
    setStepPending(false);
}

export function wizardDescriptionRequest(url, data) {
    const superseded = descriptionRequest;
    const request = scriptRequest(url, data);
    const isCurrent = () => descriptionRequest === request;

    descriptionRequest = request;

    abortRequest(superseded);

    return request.done(function() {
        if (isCurrent()) descriptionRequest = null;
    }).fail(function() {
        if (!isCurrent()) return;

        descriptionRequest = null;
        showFlash('danger', wizardMessage('description-request-failed-message'));
    });
}

// Passing the step index explicitly is required; bootstrapWizard('next') jumps to the last step.
export function advanceWizardStep(form, step) {
    return wizardRequest(form).done(function() {
        wizardCard().bootstrapWizard('show', step);
    });
}

// The wizard tabs render inline :javascript blocks that esbuild never sees, so these three
// have to stay reachable as globals.
window.wizardRequest = wizardRequest;
window.advanceWizardStep = advanceWizardStep;
window.wizardStepRequestPending = wizardStepRequestPending;
